<template>
  <div>
    <section class="section position-relative">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
            <accountMenu />
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="title">System Credit Points</h3>
              <!-- <b-button @click="showFormAdd" variant="outline-primary"
                >Add Point</b-button
              > -->
            </div>

            <p class="border-bottom-cus mt-2"></p>

            <div class="mb-3">
              <h5>Usage Statistics</h5>
            </div>
            <b-container fluid>
              <b-row>
                <b-col>
                  <div class="text-center">
                    <h4>
                      {{ creditPointData != null ? creditPointData.point : 0 }}
                    </h4>
                    <div>Remainning Point</div>
                  </div>
                </b-col>
                <b-col>
                  <div class="text-center">
                    <h4>0</h4>
                    <div>Usaged Point</div>
                  </div>
                </b-col>
              </b-row>
            </b-container>

            <div class="mb-2 mt-4">
              <h5>Add Point History</h5>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-responsive bg-white">
                  <v-data-table
                    :headers="headers"
                    :items-per-page="10"
                    :items="billingHistory"
                    class="table table-center table-padding mb-0"
                  >
                    <template v-slot:item.created_at="{ item }">
                      {{ item.created_at | moment("DD/MM/YYYY HH:mm:ss") }}
                    </template>
                    <template v-slot:item.amount="{ item }">
                      {{ item.amount | numFormat("0,0.00") }}
                    </template>
                    <template v-slot:item.paid="{ item }">
                      <!-- <check-circle-icon
                        v-if="item.paid"
                        size="1.5x"
                        class="text-primary"
                      ></check-circle-icon>
                      <x-circle-icon
                        v-else
                        size="1.5x"
                        class="text-danger"
                      ></x-circle-icon> -->
                      <div v-if="item.paid" class="badge badge-custom">
                        <check-circle-icon
                          size="1.5x"
                          class="mr-2"
                        ></check-circle-icon
                        >paid
                      </div>
                      <div v-else class="badge badge-custom2">
                        <x-circle-icon size="1.5x" class="mr-2"></x-circle-icon
                        >failed
                      </div>
                    </template>
                    <template v-slot:item.receipt="{ item }">
                      <router-link
                        :to="{
                          name: 'Receipt',
                          params: { id: item._id },
                        }"
                        v-slot="{ href, navigate }"
                        custom
                        target="_blank"
                      >
                        <a
                          :href="href"
                          @click="navigate"
                          class="btn btn-icon btn-outline-primary"
                        >
                          <i class="uil uil-invoice"></i>
                        </a>
                      </router-link>
                    </template>
                  </v-data-table>
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>
        </div>
      </div>

      <b-overlay :show="overlay" no-wrap> </b-overlay>
    </section>

    <b-modal
      id="modal-add-point"
      title="Add system points"
      centered
      v-model="modalAdd"
      @ok="submitForm"
    >
      <b-form novalidate>
        <b-form-group label="Amount:" description="System will charge tax 7%">
          <b-form-input
            v-model.number="model.amount"
            type="number"
            placeholder="Enter amount"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>

      <div class="mt-4">
        <h6>Choose payment method</h6>
      </div>
      <div class="row no-gutters mt-3">
        <template v-for="(card, idx) of paymentMethods">
          <div class="col-12 py-1" :key="`customer_card_${idx}`">
            <div class="row no-gutters">
              <div class="col-6">
                <div class="custom-control custom-radio custom-control-inline">
                  <div class="form-group mb-0">
                    <input
                      type="radio"
                      :id="`exist_card_${idx}`"
                      :name="`exist_card_${idx}`"
                      class="custom-control-input"
                      :value="card.id"
                      v-model="model.card"
                    />
                    <label
                      :for="`exist_card_${idx}`"
                      class="custom-control-label"
                      >{{ card.name }}</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-6">
                {{ card.brand }}
                **** {{ card.last_digits }}
                <!-- (expires
                {{ card.expiration_month.toString().padStart(2, 0) }}/{{
                  card.expiration_year
                }}) -->
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from "vue-feather-icons";

import omiseService from "../../../services/omiseService";
import { getCreditPointData } from "../../../services/infoService";
import accountMenu from "../menu";
export default {
  components: {
    CheckCircleIcon,
    XCircleIcon,
    accountMenu,
  },
  data: () => ({
    headers: [
      {
        text: "Invoice No.",
        align: "center",
        sortable: false,
        value: "invoiceNo",
      },
      {
        text: "Date",
        align: "center",
        sortable: false,
        value: "created_at",
      },
      {
        text: "Amount (THB)",
        align: "right",
        sortable: false,
        value: "amount",
      },
      {
        text: "Point",
        align: "right",
        sortable: false,
        value: "point",
      },
      {
        text: "Status",
        align: "center",
        sortable: false,
        value: "paid",
      },
      {
        text: "Receipt",
        align: "center",
        sortable: false,
        value: "receipt",
      },
    ],
    billingHistory: [],
    modalAdd: false,
    paymentMethods: [],
    overlay: false,
    progressModal: false,
    model: {
      amount: 0,
      card: null,
    },
    creditPointData: null,
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.overlay = true;
      let reqs = [
        omiseService.listCards(),
        getCreditPointData(),
        omiseService.listBillingHistory(),
      ];
      Promise.all(reqs)
        .then((resps) => {
          const respCards = resps[0];
          if (respCards.data.status && respCards.data.result.total > 0) {
            this.paymentMethods = respCards.data.result.data;
          }

          const respCreditPoint = resps[1];
          this.creditPointData = respCreditPoint.data;

          const respBilling = resps[2];
          if (respBilling.data.status) {
            this.billingHistory = respBilling.data.result;
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.overlay = false;
        });
    },
    submitForm() {
      this.overlay = true;
      omiseService
        .charge(this.model)
        .then((resp) => {
          if (resp.data.failureCode != null && resp.data.paid == false) {
            this.$bvModal.msgBoxOk(resp.data.failureMessage, {
              title: "Error",
              centered: true,
              okVariant: "danger",
            });
          } else {
            this.init();
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.overlay = false;
        });
    },
    showFormAdd() {
      if (this.paymentMethods.length == 0) {
        this.$bvModal
          .msgBoxOk(
            "You not have payment method yet, please add before add points.",
            {
              title: "Required Payment Methods",
              centered: true,
            }
          )
          .then(() => {
            this.$router.push({
              path: "/account/creditcard",
            });
          });
      } else {
        this.modalAdd = true;
      }
    },
  },
};
</script>